import { project2BaseUrl } from './remoteClient';

export async function occupationalFamilyTitlesRequest(token) {
    return await project2BaseUrl.get("/skillsEngine/getOccupationFamilyTitles", {
        headers: {
            Authorization: `Bearer ${token}`
        }
    });
}